import React, { useEffect, useState } from "react";
import { Databases, Storage } from "appwrite";
import client from "./appwriteConfig";
import "./css/SoldProductModal.css";
import { BeatLoader } from "react-spinners";

const databases = new Databases(client);
const storage = new Storage(client);

const SoldProductModal = ({ product, onClose }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchPreview = async () => {
      if (!product?.productType || !product?.productId) return;
      setLoading(true);
      try {
        if (product.productType === "beat") {
          const beatData = await databases.getDocument(
            process.env.REACT_APP_DATABASE_ID,
            process.env.REACT_APP_COLLECTION_BEATS_ID,
            product.productId
          );
          setPreviewUrl(beatData.imageUrl);
        } else if (product.productType === "tutorial") {
          const tutorialData = await databases.getDocument(
            process.env.REACT_APP_DATABASE_ID,
            process.env.REACT_APP_COLLECTION_TUTORIALS_ID,
            product.productId
          );
          if (tutorialData.videos) {
            const videos = JSON.parse(tutorialData.videos);
            if (Array.isArray(videos) && videos.length > 0) {
              setPreviewUrl(videos[0].thumbnailUrl);
            }
          }
        } else if (product.productType === "fashion") {
          const fashionData = await databases.getDocument(
            process.env.REACT_APP_DATABASE_ID,
            process.env.REACT_APP_COLLECTION_FASHION_ID,
            product.productId
          );
          const fashionImgId = fashionData.fashionUrl;
          const fileView = await storage.getFileView(
            process.env.REACT_APP_BUCKET_FASHION_ID,
            fashionImgId
          );
          setPreviewUrl(fileView.href);
        }
      } catch (error) {
        console.error("Error fetching preview:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPreview();
  }, [product]);

  if (!product) return null;

  return (
    <div className="sold-modal-overlay">
      <div className="sold-modal-content">
        <button className="sold-close-modal" onClick={onClose}>
          ✖
        </button>

        <h2>Product Details</h2>
        <div className="sold-preview-wrapper">
          {loading ? (
            <BeatLoader color="#1a73e8" />
          ) : (
            previewUrl && (
              <img
                src={previewUrl}
                alt="Product Preview"
                className="sold-product-preview"
              />
            )
          )}
        </div>

        <table className="sold-product-info-table">
          <tbody>
            <tr>
              <td>
                <strong>Product Name:</strong>
              </td>
              <td>{product.productName}</td>
            </tr>
            <tr>
              <td>
                <strong>Product ID:</strong>
              </td>
              <td>{product.productId}</td>
            </tr>
            <tr>
              <td>
                <strong>Type:</strong>
              </td>
              <td>{product.productType}</td>
            </tr>
            <tr>
              <td>
                <strong>Quantity:</strong>
              </td>
              <td>{product.quantity ?? "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>Cost:</strong>
              </td>
              <td>₹{product.cost}</td>
            </tr>
            <tr>
              <td>
                <strong>Total Cost:</strong>
              </td>
              <td>₹{product.totalCost}</td>
            </tr>
            <tr>
              <td>
                <strong>Platform Fee:</strong>
              </td>
              <td>₹{product.platformFee}</td>
            </tr>
            <tr>
              <td>
                <strong>Seller Cost:</strong>
              </td>
              <td>₹{product.sellerCost}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SoldProductModal;
